import React, { useEffect, useState } from 'react';
import { X, Plus, Filter, Check, AlertCircle } from 'lucide-react';
interface LinkedInFiltersProps {
  initialFilters?: string[];
  onApplyFilters?: (filters: string[]) => void;
  onAddFilter?: (filter: string) => void;
  onRemoveFilter?: (index: number) => void;
  appliedFilters?: boolean;
  disableModification?: boolean;
}
export const LinkedInFilters = ({
  initialFilters,
  onApplyFilters,
  onAddFilter,
  onRemoveFilter,
  appliedFilters = false,
  disableModification = false
}: LinkedInFiltersProps) => {
  const [filters, setFilters] = useState(initialFilters || ['Industry: Technology', 'Company size: 50-200', 'Location: United States']);
  const [newFilter, setNewFilter] = useState('');
  // Update filters when initialFilters changes
  useEffect(() => {
    if (initialFilters) {
      setFilters(initialFilters);
    }
  }, [initialFilters]);
  const addFilter = () => {
    if (newFilter.trim()) {
      const updatedFilters = [...filters, newFilter.trim()];
      setFilters(updatedFilters);
      if (onAddFilter) {
        onAddFilter(newFilter.trim());
      }
      setNewFilter('');
    }
  };
  const removeFilter = (indexToRemove: number) => {
    const updatedFilters = filters.filter((_, index) => index !== indexToRemove);
    setFilters(updatedFilters);
    if (onRemoveFilter) {
      onRemoveFilter(indexToRemove);
    }
  };
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      addFilter();
    }
  };
  const handleApplyFilters = () => {
    if (onApplyFilters) {
      onApplyFilters(filters);
    }
  };
  return <div className="space-y-4" data-id="element-525">
      <div className="space-y-2" data-id="element-526">
        {filters.map((filter, index) => <div key={index} className={`flex items-center justify-between px-3 py-2 rounded-md ${appliedFilters ? 'bg-green-50 border border-green-200' : 'bg-gray-50 border border-gray-200'}`} data-id="element-527">
            <div className="flex items-center gap-2" data-id="element-528">
              {appliedFilters && <Check size={16} className="text-green-600" data-id="element-529" />}
              <span className={`text-sm ${appliedFilters ? 'text-green-700' : 'text-gray-700'}`} data-id="element-530">
                {filter}
              </span>
            </div>
            {!disableModification && <button onClick={() => removeFilter(index)} className="text-gray-400 hover:text-red-500" data-id="element-531">
                <X size={16} data-id="element-532" />
              </button>}
          </div>)}
      </div>
      {!disableModification && <div className="flex gap-2 mt-4" data-id="element-533">
          <div className="relative flex-1" data-id="element-534">
            <input type="text" value={newFilter} onChange={e => setNewFilter(e.target.value)} onKeyDown={handleKeyDown} placeholder="Add new filter (e.g., Role: CTO)" className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none" data-id="element-535" />
          </div>
          <button onClick={addFilter} className="px-3 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 flex items-center gap-1" disabled={!newFilter.trim()} data-id="element-536">
            <Plus size={16} data-id="element-537" />
            Add
          </button>
        </div>}
      {!appliedFilters && <div className="flex items-center justify-between mt-4 pt-4 border-t border-gray-200" data-id="element-538">
          <div className="flex items-center text-amber-600 text-sm" data-id="element-539">
            <AlertCircle size={16} className="mr-2" data-id="element-540" />
            Filters need to be applied before discovering prospects
          </div>
          <button onClick={handleApplyFilters} className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 flex items-center gap-2" data-id="element-541">
            <Check size={18} data-id="element-542" />
            Apply LinkedIn Filters
          </button>
        </div>}
      {appliedFilters && <div className="flex items-center text-green-600 text-sm mt-4 pt-4 border-t border-gray-200" data-id="element-543">
          <Check size={16} className="mr-2" data-id="element-544" />
          Filters applied successfully. You can now discover prospects.
          {disableModification && <span className="ml-1 text-gray-500" data-id="element-545">(Filters are locked)</span>}
        </div>}
    </div>;
};